// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../../common/util.bs.js";
import * as StaticImage from "../../../StaticImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";

function MemberDetail(props) {
  var member = props.member;
  var memberPhoto_src = member.imgUrl;
  var memberPhoto_alt = member.altTag;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(StaticImage.make, {
                            src: memberPhoto_src,
                            alt: memberPhoto_alt,
                            width: 650,
                            height: 928,
                            className: "inline-block"
                          }),
                      className: "lg:w-5/12 md:w-8/12 w-11/12 mx-auto lg:ml-0 h-full xl:w-1/3"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("h1", {
                                    children: Util.ReactStuff.s(member.name),
                                    className: "text-3xl text-prezzee-red font-semibold"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: Util.ReactStuff.s(member.position),
                                    className: "text-mid-gray text-sm"
                                  }),
                              JsxRuntime.jsxs("a", {
                                    children: [
                                      JsxRuntime.jsx("u", {
                                            children: Util.ReactStuff.s(" LinkedIn")
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                                  icon: [
                                                    "fab",
                                                    "linkedin-in"
                                                  ]
                                                }),
                                            className: "rounded-full h-8 w-8 text-white justify-center flex items-center bg-prezzee-blue ml-3 my-5"
                                          })
                                    ],
                                    "aria-label": member.name + " at LinkedIn",
                                    className: "flex items-center w-32",
                                    href: member.linkedIn,
                                    target: "_blank"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: Util.ReactStuff.s(member.description),
                                    className: "whitespace-pre-line"
                                  })
                            ],
                            className: "w-full lg:w-10/12 xl:w-9/12 mx-auto my-3"
                          }),
                      className: "w-11/12 md:w-8/12 mx-auto lg:w-7/12"
                    })
              ],
              className: "lg:flex lg:items-center min-h-0"
            });
}

var Img;

var make = MemberDetail;

export {
  Img ,
  make ,
}
/* Util Not a pure module */
